export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.498 4.912h4.665c.184 0 .333.15.333.333l-.002 5.671H3.5v-5.67c0-.185.149-.334.333-.334h1.239l2.194 2.731c.08.092.232.036.232-.086V4.912zm-3.709 8.842a.6.6 0 01-.289-.513v-.329h9v.325a.6.6 0 01-.294.516l-2.062 1.434a1.326 1.326 0 00-.642 1.067v3.163a1.495 1.495 0 01-2.99.001v-3.117a1.331 1.331 0 00-.639-1.11l-2.084-1.437z\" fill=\"#5C6270\"/>",
  "attrs": {
    "width": "16",
    "height": "25",
    "viewBox": "0 0 16 25",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};